import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WhitespaceOnlyDirective} from './whitespace-only.directive';
import {QuantityIncrementDirective} from './quantity-match-increment.directive';


@NgModule({
  declarations: [
    WhitespaceOnlyDirective,
    QuantityIncrementDirective
  ],
  exports: [
    WhitespaceOnlyDirective,
    QuantityIncrementDirective
  ],
  imports: [
    CommonModule
  ]
})
export class ValidatorsModule {
}
